module.exports = function() {
  return new Worker(__webpack_public_path__ + "7c0ff8bbe960a9aa3d29.worker.js");
};